/*
 * This file is part of the Det Norske Teatret Nettside 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';

interface FullscreenProps {
  title?: string;
}

/**
 * This is the Fullscreen component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 */
function Fullscreen({ title = 'Fullscreen' }: FullscreenProps) {
  return (
    <span className="svg svg-square svg-fullscreen">
      <span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>{title}</title>
          <path
            d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
            fill="black"
          />
        </svg>
      </span>
    </span>
  );
}

export default Fullscreen;
